import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const SheetActionCategoryForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="SheetActionCategory" id={match.params.id} initialValues={{ name: null }}>
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg={4}>
                    <Input name="name" />
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

SheetActionCategoryForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default SheetActionCategoryForm;
